import { useEffect, useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import api from "../api";

const itDate = (iso) => {
  if (!iso || String(iso).length < 10) return iso || "—";
  const p = String(iso).slice(0, 10).split("-");
  return p.length === 3 ? `${p[2]}/${p[1]}/${p[0]}` : iso;
};
const Pct = ({ v }) => <span className="muted" style={{ fontSize: 12 }}>{v == null ? "—" : `${v}%`}</span>;

const DA_LABELS = {
  "risultato-alto": "Pulsante riquadro compatto (risultato-alto)",
  "risultato-basso": "Pulsante riquadro finale (risultato-basso)",
  "esito": "Email dell'esito",
  "—": "Senza provenienza",
};

function GoogleAdsPanel() {
  const [f, setF] = useState(null);
  useEffect(() => { api.get("/gads/funnel").then((r) => setF(r.data)).catch(() => {}); }, []);
  const dl = async (path, fname) => {
    try {
      const r = await api.get(path, { responseType: "blob" });
      const url = URL.createObjectURL(r.data);
      const a = document.createElement("a");
      a.href = url; a.download = fname;
      document.body.appendChild(a); a.click(); a.remove();
      URL.revokeObjectURL(url);
    } catch { alert("Export non riuscito, riprova."); }
  };
  return (
    <div className="panel" data-testid="mc-gads-panel">
      <h3>📈 Google Ads — conversioni e funnel</h3>
      {f && (
        <p style={{ fontSize: 13.5, lineHeight: 1.7 }} data-testid="gads-funnel-numbers">
          🩺 Check-up compilati: <strong>{f.checkup_compilati}</strong> → 💳 hanno pagato la consulenza: <strong>{f.hanno_pagato_consulenza}</strong>
          {f.pct_checkup_to_consulenza != null && <> (<strong>{f.pct_checkup_to_consulenza}%</strong>)</>} → 🤝 clienti continuativi: <strong>{f.clienti_continuativi}</strong>
          {f.pct_consulenza_to_cliente != null && <> (<strong>{f.pct_consulenza_to_cliente}%</strong>)</>}<br />
          💶 Valore medio cliente/anno: <strong>{f.valore_medio_cliente_anno_eur ?? "—"} €</strong> · ⏳ durata media rapporto: <strong>{f.durata_media_rapporto_anni ?? "—"} anni</strong><br />
          🧹 Lead non utilizzabili: <strong>{f.qualita.pct_non_utilizzabili}%</strong> <span className="muted">({f.qualita.indirizzi_email_bloccati} email bloccate · {f.qualita.esclusi_fuori_target} fuori target · {f.qualita.lead_cancellati} cancellati)</span>
        </p>
      )}
      <div className="toolbar" style={{ marginTop: 8 }}>
        <button className="btn primary" data-testid="gads-export-conversions" onClick={() => dl("/gads/conversions.csv?days=90", "conversioni_google_ads.csv")}>⬇️ CSV conversioni (per Google Ads)</button>
        <button className="btn" data-testid="gads-export-leads" onClick={() => dl("/gads/leads.csv?months=12", "storico_lead_12mesi.csv")}>⬇️ CSV storico lead (12 mesi)</button>
      </div>
      <p className="muted" style={{ fontSize: 12, marginTop: 6 }}>
        Il CSV conversioni contiene solo i lead con GCLID che hanno pagato: caricalo in Google Ads → Obiettivi → Conversioni → Importazioni.
      </p>
    </div>
  );
}

function RecuperoStripe() {
  const [days, setDays] = useState(7);
  const [busy, setBusy] = useState(false);
  const [res, setRes] = useState(null);
  const [err, setErr] = useState("");

  const run = async () => {
    setBusy(true); setErr(""); setRes(null);
    try {
      const r = await api.post("/stripe/recover", { days: Number(days) || 7 });
      setRes(r.data);
    } catch (e) { setErr(e.response?.data?.detail || e.message); }
    setBusy(false);
  };

  return (
    <div className="panel" data-testid="mc-stripe-recover-panel">
      <h3>💳 Recupero pagamenti Stripe</h3>
      <p className="muted" style={{ fontSize: 13, margin: "4px 0 10px" }}>
        Interroga Stripe e registra nel CRM i pagamenti che il webhook ha perso. Sicuro da rilanciare: i pagamenti già registrati non vengono toccati.
      </p>
      <div className="toolbar">
        <label style={{ fontSize: 13 }}>Ultimi
          <input type="number" min="1" max="90" value={days} onChange={(e) => setDays(e.target.value)}
                 style={{ width: 64, margin: "0 6px" }} data-testid="stripe-recover-days" /> giorni</label>
        <button className="btn primary" onClick={run} disabled={busy} data-testid="stripe-recover-btn">
          {busy ? "Controllo su Stripe…" : "🔍 Controlla e registra"}
        </button>
      </div>
      {err && <p style={{ color: "var(--danger)", fontSize: 13 }} data-testid="stripe-recover-error">⚠️ {err}</p>}
      {res && (
        <div data-testid="stripe-recover-result">
          <p style={{ fontSize: 13.5, margin: "10px 0 8px" }}>
            <strong>{res.pagamenti.length}</strong> pagamenti trovati negli ultimi {res.giorni} giorni
            {res.modalita === "test" && <span className="muted"> (ambiente di prova: Stripe in modalità test)</span>} ·{" "}
            <strong>{res.registrati_ora}</strong> registrati ora
          </p>
          {res.pagamenti.length > 0 && (
            <table>
              <thead><tr><th>Data</th><th>Email</th><th>Importo</th><th>Esito</th></tr></thead>
              <tbody>
                {res.pagamenti.map((p, i) => (
                  <tr key={i} data-testid={`stripe-recover-row-${i}`}>
                    <td>{itDate(p.data)}</td><td>{p.email}</td><td>{p.importo.toFixed(2)} €</td>
                    <td style={p.esito.includes("✓") ? { color: "var(--ok, #4ade80)", fontWeight: 700 } : {}}>{p.esito}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      )}
    </div>
  );
}

export default function MonitorCheckup() {
  const navigate = useNavigate();
  const [stato, setStato] = useState(null);
  const [imbuto, setImbuto] = useState(null);
  const [invii, setInvii] = useState([]);
  const [leads, setLeads] = useState([]);
  const [da, setDa] = useState("");
  const [a, setA] = useState("");
  const [seg, setSeg] = useState("");
  const [segL, setSegL] = useState("");
  const [statoF, setStatoF] = useState("");
  const [scadEntro, setScadEntro] = useState("");

  const loadImbuto = useCallback(() => {
    const p = new URLSearchParams();
    if (da) p.set("da", da);
    if (a) p.set("a", a);
    if (seg) p.set("segmento", seg);
    api.get(`/funnels/checkup/imbuto?${p}`).then((r) => setImbuto(r.data)).catch(() => {});
  }, [da, a, seg]);

  useEffect(() => {
    api.get("/funnels/checkup/stato").then((r) => setStato(r.data)).catch(() => {});
    api.get("/funnels/checkup/prossimi-invii?giorni=7").then((r) => setInvii(r.data)).catch(() => {});
    api.get("/pipeline").then((r) => setLeads(r.data.filter((l) => l.data_checkup))).catch(() => {});
  }, []);
  useEffect(() => { loadImbuto(); }, [loadImbuto]);

  const toggle = async (flusso, current, field) => {
    const r = await api.post("/funnels/checkup/interruttore", { flusso, enabled: !current });
    if (flusso === "febbraio") setStato({ ...stato, febbraio_ok: r.data.febbraio_ok });
    else setStato({ ...stato, [field]: r.data.attivo ?? r.data.sequenza_attiva });
  };

  const segments = [...new Set(leads.map((l) => l.segmento).filter(Boolean))].sort();
  const stati = [...new Set(leads.map((l) => l.stato_funnel).filter(Boolean))].sort();
  const horizon = scadEntro ? new Date(Date.now() + Number(scadEntro) * 86400000).toISOString().slice(0, 10) : "";
  const filtered = leads.filter((l) => {
    if (segL && (l.segmento || "") !== segL) return false;
    if (statoF && (l.stato_funnel || "") !== statoF) return false;
    if (scadEntro && !(l.prossima_scadenza && l.prossima_scadenza <= horizon)) return false;
    return true;
  }).sort((x, y) => (x.prossima_scadenza || "9999").localeCompare(y.prossima_scadenza || "9999"));

  const FUNNEL_STEPS = imbuto ? [
    ["Check-up compilati", imbuto.compilati, null],
    ["Clic sull'offerta", imbuto.cliccati_offerta, imbuto.pct.clic_su_compilati],
    ["Pagina d'ordine aperta", imbuto.pagina_ordine, imbuto.pct.ordine_su_compilati],
    ["Hanno pagato", imbuto.pagati, imbuto.pct.pagati_su_compilati],
  ] : [];

  return (
    <div data-testid="monitor-checkup-page">
      <h1 className="page-title">Monitor Check-up</h1>
      <p className="page-sub">Imbuto, invii in programma e contatti con una finestra normativa che si chiude</p>

      {stato && (
        <div className="panel" data-testid="mc-stato-bar" style={{ display: "flex", flexDirection: "column", gap: 8 }}>
          <div className="toolbar" data-testid="mc-flusso-seq">
            <span>{stato.sequenza_attiva ? "🟢" : "⛔"} <strong>Sequenza di ingresso (A)</strong> · {stato.contatti_in_sequenza} contatti in sequenza</span>
            <div className="spacer" />
            <button className={"btn " + (stato.sequenza_attiva ? "danger" : "primary")} onClick={() => toggle("seq", stato.sequenza_attiva, "sequenza_attiva")} data-testid="mc-kill-switch">
              {stato.sequenza_attiva ? "⛔ Ferma" : "▶ Riattiva"}
            </button>
          </div>
          <div className="toolbar" data-testid="mc-flusso-carrello">
            <span>{stato.carrello_attivo ? "🟢" : "⛔"} <strong>Carrello abbandonato (B)</strong> · email a 3 e 48 ore da chi apre la pagina d'ordine senza comprare{stato.contatti_in_carrello > 0 && <> · {stato.contatti_in_carrello} nel flusso ora</>}</span>
            <div className="spacer" />
            <button className={"btn " + (stato.carrello_attivo ? "danger" : "primary")} onClick={() => toggle("carrello", stato.carrello_attivo, "carrello_attivo")} data-testid="mc-switch-carrello">
              {stato.carrello_attivo ? "⛔ Ferma" : "▶ Riattiva"}
            </button>
          </div>
          <div className="toolbar" data-testid="mc-flusso-calendario">
            <span>{stato.calendario_attivo ? "🟢" : "⛔"} <strong>Calendario fiscale (E)</strong> · 15/9 tutti · ~20/10 società · 15/11 tutti · 15/1 ditte e forfettari · 15/2 tutti</span>
            <div className="spacer" />
            <button className={"btn " + (stato.calendario_attivo ? "danger" : "primary")} onClick={() => toggle("calendario", stato.calendario_attivo, "calendario_attivo")} data-testid="mc-switch-calendario">
              {stato.calendario_attivo ? "⛔ Ferma" : "▶ Riattiva"}
            </button>
          </div>
          <div className="toolbar" data-testid="mc-flusso-rifai">
            <span>{stato.rifai_attivo ? "🟢" : "⛔"} <strong>Rifai il check-up (F)</strong> · invito 12 mesi dopo la compilazione, la nuova compilazione fa ripartire la sequenza</span>
            <div className="spacer" />
            <button className={"btn " + (stato.rifai_attivo ? "danger" : "primary")} onClick={() => toggle("rifai", stato.rifai_attivo, "rifai_attivo")} data-testid="mc-switch-rifai">
              {stato.rifai_attivo ? "⛔ Ferma" : "▶ Riattiva"}
            </button>
          </div>
          <div className="toolbar" data-testid="mc-flusso-spegnimento">
            <span>{stato.spegnimento_attivo ? "🟢" : "⛔"} <strong>Spegnimento (G)</strong> · 6 mesi senza clic → ultima email; senza clic in 14 giorni diventa inattivo{stato.contatti_inattivi > 0 && <> · {stato.contatti_inattivi} inattivi</>}</span>
            <div className="spacer" />
            <button className={"btn " + (stato.spegnimento_attivo ? "danger" : "primary")} onClick={() => toggle("spegnimento", stato.spegnimento_attivo, "spegnimento_attivo")} data-testid="mc-switch-spegnimento">
              {stato.spegnimento_attivo ? "⛔ Ferma" : "▶ Riattiva"}
            </button>
          </div>
          <div className="toolbar" data-testid="mc-flusso-nurture">
            <span style={{ fontSize: 13 }}>📰 <strong>Nurture (C)</strong> · dal giorno 21, una newsletter ogni 18 giorni (in ordine, filtrata per segmento, offerta solo in una riga fissa in fondo) — si gestisce dalla sezione Newsletter della pagina Funnel</span>
          </div>
          <div className="toolbar" data-testid="mc-flusso-febbraio">
            <span style={{ fontSize: 13 }}>{stato.febbraio_ok ? "🟢" : "⏸"} <strong>cal-febbraio</strong> · {stato.febbraio_ok ? "sbloccata: partirà il 15 febbraio" : "FERMA finché non confermi l'aggiornamento annuale dei parametri del questionario"}</span>
            <div className="spacer" />
            <button className={"btn " + (stato.febbraio_ok ? "danger" : "primary")} onClick={() => toggle("febbraio", stato.febbraio_ok)} data-testid="mc-switch-febbraio">
              {stato.febbraio_ok ? "⏸ Rimetti in attesa" : "✅ Parametri aggiornati: sblocca"}
            </button>
          </div>
        </div>
      )}
      <CampagnaPanel />
      <GoogleAdsPanel />
      <RecuperoStripe />

      <div className="panel" data-testid="mc-imbuto-panel">
        <h3>📊 Imbuto</h3>
        <div className="toolbar" style={{ marginTop: 6 }}>
          <label style={{ fontSize: 13 }}>Dal <input type="date" value={da} onChange={(e) => setDa(e.target.value)} data-testid="mc-da" /></label>
          <label style={{ fontSize: 13 }}>Al <input type="date" value={a} onChange={(e) => setA(e.target.value)} data-testid="mc-a" /></label>
          <select value={seg} onChange={(e) => setSeg(e.target.value)} data-testid="mc-segmento">
            <option value="">— tutti i segmenti —</option>
            {segments.map((s) => <option key={s} value={s}>{s}</option>)}
          </select>
        </div>
        {imbuto && (
          <>
            <div className="dash-cards">
              {FUNNEL_STEPS.map(([lbl, n, pct], i) => (
                <div key={lbl} className={"dash-card" + (i === 3 ? " highlight" : "")} data-testid={`mc-step-${i}`}>
                  <div className="num">{n}</div>
                  <div className="lbl">{lbl}{pct != null && <> · <Pct v={pct} /> dei compilati</>}</div>
                </div>
              ))}
            </div>
            <p className="muted" style={{ fontSize: 12 }}>
              Passaggi: compilati → clic {imbuto.pct.clic_su_compilati ?? "—"}% · clic → pagina d'ordine {imbuto.cliccati_offerta ? Math.round(imbuto.pagina_ordine * 100 / imbuto.cliccati_offerta) : "—"}% · pagina d'ordine → pagato {imbuto.pct.pagati_su_ordine ?? "—"}%
              {imbuto.visite_anonime_pagina_ordine > 0 && <> · più {imbuto.visite_anonime_pagina_ordine} visite anonime alla pagina d'ordine</>}
            </p>
            {(imbuto.provenienze || []).length > 0 && (
              <div style={{ marginTop: 8 }} data-testid="mc-provenienze">
                <h4 style={{ margin: "6px 0" }}>Da dove arrivano clic e visite</h4>
                <table>
                  <thead><tr><th>Provenienza</th><th>Clic sull'offerta</th><th>Pagina d'ordine</th></tr></thead>
                  <tbody>
                    {imbuto.provenienze.map((p) => (
                      <tr key={p.da} data-testid={`mc-prov-${p.da}`}>
                        <td>{DA_LABELS[p.da] || (p.da.startsWith("seq") ? `Email sequenza (${p.da})` : p.da)}</td>
                        <td>{p.clic_offerta}{p.clic_anonime > 0 && <span className="muted" style={{ fontSize: 11 }}> +{p.clic_anonime} anonime</span>}</td>
                        <td>{p.pagina_ordine}{p.ordine_anonime > 0 && <span className="muted" style={{ fontSize: 11 }}> +{p.ordine_anonime} anonime</span>}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </>
        )}
      </div>

      <div className="panel" data-testid="mc-invii-panel">
        <h3>📅 In partenza nei prossimi 7 giorni ({invii.length})</h3>
        {invii.length === 0 ? <p className="empty">Nessun invio in programma.</p> : (
          <table>
            <thead><tr><th>Quando</th><th>A chi</th><th>Flusso</th><th>Oggetto</th><th>Nota</th></tr></thead>
            <tbody>
              {invii.map((r, i) => (
                <tr key={i} data-testid={`mc-invio-${i}`}>
                  <td style={{ whiteSpace: "nowrap" }}>{r.quando.startsWith("ORA") ? r.quando : itDate(r.quando)}</td>
                  <td>{r.nome ? <><strong>{r.nome}</strong><br /></> : null}{r.a}</td>
                  <td className="muted" style={{ fontSize: 12 }}>{r.flusso}</td>
                  <td style={{ fontSize: 13 }}>{r.oggetto}</td>
                  <td className="muted" style={{ fontSize: 11 }}>{r.nota}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>

      <div className="panel" data-testid="mc-contatti-panel">
        <h3>🎯 Contatti check-up ({filtered.length})</h3>
        <div className="toolbar" style={{ marginTop: 6 }}>
          <select value={segL} onChange={(e) => setSegL(e.target.value)} data-testid="mc-f-segmento">
            <option value="">— tutti i segmenti —</option>
            {segments.map((s) => <option key={s} value={s}>{s}</option>)}
          </select>
          <select value={statoF} onChange={(e) => setStatoF(e.target.value)} data-testid="mc-f-stato">
            <option value="">— tutti gli stati funnel —</option>
            {stati.map((s) => <option key={s} value={s}>{s}</option>)}
          </select>
          <select value={scadEntro} onChange={(e) => setScadEntro(e.target.value)} data-testid="mc-f-scadenza">
            <option value="">— qualsiasi scadenza —</option>
            <option value="14">scadenza entro 14 giorni</option>
            <option value="30">scadenza entro 30 giorni</option>
            <option value="60">scadenza entro 60 giorni</option>
            <option value="90">scadenza entro 90 giorni</option>
          </select>
        </div>
        {filtered.length === 0 ? <p className="empty">Nessun contatto con questi filtri.</p> : (
          <table>
            <thead><tr><th>Contatto</th><th>Segmento</th><th>Stato funnel</th><th>Prossima scadenza</th><th>Leva in scadenza</th><th>Compilato il</th></tr></thead>
            <tbody>
              {filtered.map((l) => (
                <tr key={l.id} onClick={() => navigate(`/lead/${l.id}`)} style={{ cursor: "pointer" }} data-testid={`mc-lead-${l.id}`}>
                  <td><strong>{l.name || "—"}</strong><br /><span className="muted" style={{ fontSize: 12 }}>{l.email}</span></td>
                  <td>{l.segmento || "—"}</td>
                  <td className="muted" style={{ fontSize: 12 }}>{l.stato_funnel || "—"}</td>
                  <td style={{ whiteSpace: "nowrap" }}>{l.prossima_scadenza ? <strong>{itDate(l.prossima_scadenza)}</strong> : "—"}</td>
                  <td className="muted" style={{ fontSize: 12 }}>{l.leva_prossima_scadenza?.titolo || "—"}</td>
                  <td className="muted" style={{ fontSize: 12 }}>{itDate(l.data_checkup)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}

function CampagnaPanel() {
  const [data, setData] = useState(null);
  const [inizio, setInizio] = useState("");
  const [budget, setBudget] = useState("30");
  const load = useCallback(() => {
    api.get("/funnels/checkup/campagna").then((r) => {
      setData(r.data);
      setInizio(r.data.config.data_inizio || "");
      setBudget(String(r.data.config.budget_giorno ?? 30));
    });
  }, []);
  useEffect(() => { load(); }, [load]);
  const save = async (payload) => {
    const r = await api.post("/funnels/checkup/campagna", payload);
    setData(r.data);
  };
  if (!data) return null;
  const eur = (v) => (v == null ? "—" : `${Number(v).toFixed(2).replace(".", ",")} €`);
  const t = data.totali;
  return (
    <div className="panel" data-testid="mc-campagna">
      <h3>📣 Campagna: spesa vs compilazioni</h3>
      <div className="toolbar" style={{ flexWrap: "wrap", gap: 8 }}>
        <label style={{ fontSize: 13 }}>Inizio campagna{" "}
          <input type="date" value={inizio} onChange={(e) => setInizio(e.target.value)} data-testid="campagna-inizio" />
        </label>
        <label style={{ fontSize: 13 }}>Budget al giorno (€){" "}
          <input type="number" min="0" step="0.5" value={budget} style={{ width: 80 }}
                 onChange={(e) => setBudget(e.target.value)} data-testid="campagna-budget" />
        </label>
        <button className="btn sm primary" data-testid="campagna-salva"
                onClick={() => save({ data_inizio: inizio, budget_giorno: parseFloat(budget || "0") })}>
          {data.config.attiva ? "Aggiorna" : "▶ Avvia il cruscotto"}
        </button>
        {data.config.attiva && (
          <button className="btn sm" data-testid="campagna-ferma" onClick={() => { if (window.confirm("Fermare il cruscotto? I dati di spesa salvati restano.")) save({ data_inizio: "" }); }}>Ferma</button>
        )}
      </div>
      {!data.config.attiva ? (
        <p className="muted" style={{ fontSize: 13 }}>Imposta la data di inizio e il budget (es. 30 € al giorno per 21 giorni) e avvia:
          il cruscotto confronta giorno per giorno la spesa con le compilazioni del check-up arrivate.</p>
      ) : (
        <>
          <div className="toolbar" style={{ gap: 18, fontSize: 14 }} data-testid="campagna-totali">
            <span>Giorni: <strong>{t.giorni}</strong></span>
            <span>Spesa totale: <strong>{eur(t.spesa)}</strong></span>
            <span>Compilazioni: <strong>{t.compilazioni}</strong></span>
            <span>Costo per compilazione: <strong>{eur(t.costo_medio)}</strong></span>
            <span>Consulenze pagate: <strong>{t.acquisti}</strong></span>
          </div>
          <table style={{ width: "100%", marginTop: 8 }} data-testid="campagna-tabella">
            <thead><tr><th>Giorno</th><th>Spesa</th><th>Compilazioni</th><th>Costo/compilazione</th><th>Consulenze pagate</th></tr></thead>
            <tbody>
              {[...data.righe].reverse().map((r) => (
                <tr key={r.giorno} data-testid={`campagna-riga-${r.giorno}`}>
                  <td>{itDate(r.giorno)}</td>
                  <td>
                    <input type="number" min="0" step="0.5" defaultValue={r.spesa} style={{ width: 80 }}
                           title={r.spesa_modificata ? "Spesa corretta a mano" : "Budget standard — correggi con la spesa reale di Meta"}
                           data-testid={`campagna-spesa-${r.giorno}`}
                           onBlur={(e) => { const v = e.target.value; if (parseFloat(v) !== r.spesa) save({ spesa_giorno: { giorno: r.giorno, spesa: v } }); }} />
                    {r.spesa_modificata && <span title="corretta a mano"> ✏️</span>}
                  </td>
                  <td><strong>{r.compilazioni}</strong></td>
                  <td>{eur(r.costo_compilazione)}</td>
                  <td>{r.acquisti || "—"}</td>
                </tr>
              ))}
            </tbody>
          </table>
          <p className="muted" style={{ fontSize: 12, marginTop: 8 }}>
            La spesa parte dal budget impostato: quando hai la spesa reale dal pannello Meta, correggila sulla riga del giorno (✏️ = corretta a mano).
            Le compilazioni sono i questionari arrivati dal sito quel giorno (ora italiana).
          </p>
        </>
      )}
    </div>
  );
}
